/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LTIAssignmentLaunchToOpenAssignmentParser = 
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('assignment')],
]);
export class LTIAssignmentLaunchToOpenAssignment extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LTIAssignmentLaunchToOpenAssignmentParser.decode(input).map(res => new LTIAssignmentLaunchToOpenAssignment(res));
    }
    static unsafeDecode(input) {
        return LTIAssignmentLaunchToOpenAssignment.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LTIAssignmentLaunchToOpenAssignmentParser.encode(data);
    }
    static schema() {
        return LTIAssignmentLaunchToOpenAssignmentParser.schema();
    }
}
